__turbopack_context__.v({
  "button": "login-module__pFsjvG__button",
  "card": "login-module__pFsjvG__card",
  "divider": "login-module__pFsjvG__divider",
  "error": "login-module__pFsjvG__error",
  "footer": "login-module__pFsjvG__footer",
  "googleButton": "login-module__pFsjvG__googleButton",
  "input": "login-module__pFsjvG__input",
  "label": "login-module__pFsjvG__label",
  "link": "login-module__pFsjvG__link",
  "logoContainer": "login-module__pFsjvG__logoContainer",
  "logoText": "login-module__pFsjvG__logoText",
  "page": "login-module__pFsjvG__page",
  "title": "login-module__pFsjvG__title",
});
